import { FC } from 'react'
import { List, Datagrid, TextField } from 'react-admin'

export const EmployeeList: FC = () => (
  <List>
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="email" />
    </Datagrid>
  </List>
)
